<mat-dialog-content> <p> {{message}} </p> </mat-dialog-content> <br/>

<mat-dialog-actions>

	<button mat-raised-button class = "btn-success" (click)="onConfirmClick()" tabindex="1" [style]="botonStyleAceptar"> {{confirmButtonText}} </button>
	<button mat-raised-button class = "btn-danger" (click) = "onRejectClick()" tabindex = "-1"  [style]="botonStyleCancel"> {{cancelButtonText}}</button>

</mat-dialog-actions>